import { InvoiceFormInputs } from 'src/pages/invoices/create/components/InvoiceEditForm'
import useSWR from 'swr'
import { GetInvoiceCalculatedAmountsResponse } from '../interfaces/api/GetInvoiceCaluclatedAmounts'
import { useApiClient } from './useApiClient'

type UseTaxesProps = {
  quantity: number
  unit_price: number
  tax_id: number
  is_withheld: boolean
}[]

const defaultCalculatedAmountResponse: GetInvoiceCalculatedAmountsResponse = {
  status: 'default',
  invoice_items: [],
  calculated_amount: {
    total_amount: 0,
    amount_of_tax_rate_0: 0,
    amount_excluding_tax_of_tax_rate_10: 0,
    amount_excluding_tax_of_tax_rate_8: 0,
    tax_amount_of_tax_rate_10: 0,
    tax_amount_of_tax_rate_8: 0,
    withholding_amount: 0
  }
}

export const useCalculatedAmounts = (
  invoice_items: UseTaxesProps,
  formTaxSetting: InvoiceFormInputs['taxSettings']
) => {
  const { apiClient } = useApiClient()
  const payload = {
    ...formTaxSetting,
    invoice_items
  }

  const { data: calculated_amount, mutate } = useSWR(
    `/invoice/calculated_amounts`,
    async () => {
      const res = await apiClient.getInvoiceCalculatedAmounts(payload)

      return res || defaultCalculatedAmountResponse
    },
    {
      dedupingInterval: 1000
    }
  )

  return {
    mutateCalculatedAmount: mutate,
    calculated_amount: calculated_amount || defaultCalculatedAmountResponse
  }
}
